import queryString from 'query-string'

export default {
  isAndroid (state) {
    return state.version.os === 'ANDROID'
  },
  isIOS (state) {
    return state.version.os === 'IOS'
  },
  isApp (state, getters) {
    return getters.isIOS || getters.isAndroid
  },
  isWeixin (state) {
    return state.version.isWeixin
  },
  hasPwdTemp (state) {
    return state.pwdTempData && state.pwdTempData.components
  },
  pwdTempMainData (state, getters) {
    return getters.hasPwdTemp ? state.pwdTempData.components[0] : {}
  },
  pwdTempSubDatas (state, getters) {
    return getters.hasPwdTemp ? state.pwdTempData.components.slice(1) : []
  },
  shareUrl (state) {
    let url = `http://${state.shareDomain}${window.location.pathname}?`
    const search = queryString.parse(window.location.search)
    const obj = {
      ...search,
      pid: state.userInfo.pid,
      relationId: state.userInfo.relationId,
      agentId: state.userInfo.agentId,
    }
    const queryArr = []
    for (let i in obj) {
      if (obj[i]) {
        queryArr.push(`${i}=${obj[i]}`)
      }
    }
    url += queryArr.join('&')
    return url
  }
}
